import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PlanDisplay } from './PlanCard';
import TherapistPlanCard from './TherapistPlanCard';

interface CoursePlansLayoutProps {
  plans: PlanDisplay[];
  isLoading: boolean;
  processingPlan: string | null;
  onSelect: (id: string, quantity?: number) => void;
}

const CoursePlansLayout: React.FC<CoursePlansLayoutProps> = ({
  plans,
  isLoading,
  processingPlan,
  onSelect,
}) => {
  const cols =
    plans.length <= 1
      ? 'max-w-md mx-auto'
      : plans.length === 2
        ? 'md:grid-cols-2 max-w-4xl mx-auto'
        : 'md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto';

  return (
    <div className="mx-auto max-w-6xl px-1 sm:px-2">
      <Link
        to="/planos"
        className="mb-8 inline-flex items-center gap-2 rounded-full border border-[#2B5A41]/20 bg-white/80 px-4 py-2 text-sm font-medium text-[#2B5A41] shadow-sm transition hover:border-[#2B5A41]/40 hover:bg-white"
      >
        <ArrowLeft className="h-4 w-4" aria-hidden />
        Voltar para escolha de caminho
      </Link>

      <header className="mb-8 max-w-3xl">
        <p className="mb-2 text-sm font-semibold uppercase tracking-[0.16em] text-[#2B5A41]">
          Consteladores e clientes
        </p>
        <h1 className="text-3xl font-bold leading-tight text-[#2B5A41] md:text-4xl">
          Cursos, mentorias e vivências
        </h1>
        <p className="mt-3 text-lg leading-relaxed text-[#5F7167]">
          Mentorias, workshops, cursos, formações e experiências sistêmicas. Constelador e cliente podem participar.
        </p>
      </header>

      {isLoading ? (
        <div className="flex flex-col items-center justify-center py-16">
          <div
            className="inline-block h-10 w-10 animate-spin rounded-full border-4 border-solid border-[#89A78C] border-r-transparent"
            role="status"
            aria-label="Carregando cursos"
          />
          <p className="mt-4 font-medium text-[#2B5A41]">Carregando...</p>
        </div>
      ) : plans.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-[#2B5A41]/30 bg-white py-16 text-center shadow-sm">
          <p className="text-[#2B5A41]">Nenhum curso, mentoria ou vivência publicado no momento.</p>
        </div>
      ) : (
        <div className={`grid grid-cols-1 gap-6 md:gap-8 ${cols}`}>
          {plans.map((plan) => (
            <TherapistPlanCard
              key={plan.id}
              plan={plan}
              onSelect={onSelect}
              isLoading={processingPlan === plan.id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CoursePlansLayout;
